import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export const CardActionsRow = styled(Box)<{ page: string }>(({ page }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '10px',
  padding: page === 'OpenTickets' ? '14px 16px 0' : '14px 20px 0',
  minHeight: '28px'
}))

export const ActionButton = styled('button')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '28px',
  height: '28px',
  padding: 0,
  border: 'none',
  borderRadius: '6px',
  background: 'transparent',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',

  '&:hover': {
    background: 'rgba(4, 126, 80, 0.08)'
  },

  '&:focus-visible': {
    outline: '2px solid #047E50',
    outlineOffset: '1px'
  }
}))
